import { Navigate, Route, Routes } from 'react-router-dom';
import { PagePlayer } from './containers';
import { InfoRoute, ResetRoute } from '@/shared';

export const PlayerRoutes = () => {
  return (
    <Routes>
      <Route index element={<PagePlayer />} />
      <Route path="reset" element={<ResetRoute />} />
      <Route path="info" element={<InfoRoute />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
